<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 8
      h1 Lingote

    img(data-aos="fade-up")(src="@/assets/curso/temas/tema8/1.png", alt="Imagen decorativa")

    .row.justify-content-center.mb-4
      .col-xl-10(data-aos="fade-down")
        div.banner-text.bg-color-primario-p10
          p.mb-0 En el proceso de elaboración de joyería, una de las etapas fundamentales es la obtención de un material metálico homogéneo, limpio y con las propiedades adecuadas para continuar con las operaciones posteriores, como el laminado, trefilado o la fabricación de piezas específicas. Este paso asegura que la mezcla de metales utilizada en la aleación mantenga su calidad, pureza y comportamiento técnico, permitiendo un mejor control durante la transformación. Además, constituye un eslabón clave para estandarizar el trabajo del joyero, evitando defectos y garantizando la continuidad del proceso productivo.

    Separador
    .row.justify-content-center.z-2
      .col-xl-10
        #t_8_1.titulo-segundo.color-acento-contenido
          .h2(data-aos="fade-right") 8.1 Concepto
    
    .row.justify-content-center.align-items-center.z-2
      .col-6.col-md-4.col-lg-3
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema8/2.png" alt="Imagen decorativa" data-aos="fade-down")
      .col-lg-7
        p Un lingote es una pieza metálica sólida obtenida tras verter metal fundido en un molde específico para permitir su enfriamiento y solidificación controlada. En joyería, los lingotes representan la forma base estandarizada a partir de la cual se lamina, estira o transforma el metal para producir alambres, láminas u otras formas necesarias para la manufactura de piezas. Su correcta elaboración garantiza que la aleación mantenga uniformidad, ausencia de impurezas visibles y propiedades mecánicas adecuadas para los procesos posteriores.

    Separador
    #t_8_2.titulo-segundo.color-acento-contenido
      .h2(data-aos="fade-right") 8.2 Clases de lingotes

    p Las clases de lingotes permiten organizar el metal según las necesidades del proceso de joyería, optimizando su transformación y garantizando mejores resultados. Esta clasificación facilita elegir el tipo adecuado para cada técnica, mejora la eficiencia en el taller y contribuye a obtener piezas finales de mayor calidad.
    p Entre estas tenemos:

    .row.justify-content-center.align-items-stretch.z-2
      .col-md-6.col-xl-3.mb-5   
        .tarjeta-avatar.p-2.mb-4.mb-xl-0
          img.w-140(src='@/assets/curso/temas/tema8/3.png', alt='imagen decorativa')
          .tarjeta.pt-5.mt-3.shadow.p-4.text-center
            h5.mt-5.mb-4.pt-4.text-center Lingote plano o para laminado
            p.text-center <strong>Descripción general</strong>
            p De forma rectangular y plana, diseñado para ser reducido en un laminador.
            p <strong>Uso principal</strong>
            p Producción de láminas, chapas, bases y estructuras planas.
      .col-md-6.col-xl-3.mb-5   
        .tarjeta-avatar.p-2.mb-4.mb-xl-0
          img.w-140(src='@/assets/curso/temas/tema8/4.png', alt='imagen decorativa')
          .tarjeta.pt-5.mt-3.shadow.p-4.text-center
            h5.mt-5.mb-4.pt-4.text-center Lingote para trefilado
            p.text-center <strong>Descripción general</strong>
            p Más largo y angosto; facilita su reducción en forma de hilo.
            p <strong>Uso principal</strong>
            p Fabricación de alambres y perfiles delgados.
      .col-md-6.col-xl-3.mb-5   
        .tarjeta-avatar.p-2.mb-4.mb-xl-0
          img.w-140(src='@/assets/curso/temas/tema8/5.png', alt='imagen decorativa')
          .tarjeta.pt-5.mt-3.shadow.p-4.text-center
            h5.mt-5.mb-4.pt-4.text-center Lingote para colado
            p.text-center <strong>Descripción general</strong>
            p Lingotes específicos para realizar nuevas fundiciones; pueden ser reutilizados.
            p <strong>Uso principal</strong>
            p Re-fundición, ajustes de aleación o recuperación de metal.
      .col-md-6.col-xl-3.mb-5   
        .tarjeta-avatar.p-2.mb-4.mb-xl-0
          img.w-140(src='@/assets/curso/temas/tema8/6.png', alt='imagen decorativa')
          .tarjeta.pt-5.mt-3.shadow.p-4.text-center
            h5.mt-5.mb-4.pt-4.text-center Lingote para forja
            p.text-center <strong>Descripción general</strong>
            p De forma más maciza para ser trabajado mediante golpes de martillo o prensa.
            p <strong>Uso principal</strong>
            p Elaboración de piezas que requieren mayor densidad y resistencia.

    Separador
    #t_8_3.titulo-segundo.color-acento-contenido
      .h2(data-aos="fade-right") 8.3 Características

    .row.justify-content-center.align-items-center.z-2.mb-5
      .col-xl-10
        .p-4.bg-arena.rounded-4
          .row.justify-content-center.align-items-center
            .col-lg-10
              p.mb-0 Los lingotes utilizados en joyería deben cumplir una serie de características que aseguran su correcta manipulación en los procesos de laminado, trefilado, forja o nueva fundición. Estas características permiten que el metal responda de manera adecuada durante su transformación, garantizando uniformidad, resistencia y calidad en las piezas finales. A continuación, se presentan de manera estructurada las principales propiedades que un lingote debe poseer para considerarse óptimo dentro del trabajo joyero.
            .d-none.d-lg-block.col-lg-2
              figure
                img(src="@/assets/curso/temas/tema8/7.svg" alt="Imagen decorativa" data-aos="fade-down")  

    .titulo-sexto.color-acento-contenido.mb-4.z-2
      h5 Tabla 8.
      span Características de los lingotes
    .tabla-a.color-secundario.tabla-a--left.z-2
      table
        caption <strong>Fuente:</strong> SENA, 2025.
        thead(style="background-color: #FAF8F4;")
          tr
            th Categoría
            th Característica
            th(colspan="2") Descripción
        tbody
          tr
            td(rowspan="3") <strong>Estructurales.</strong>
            td Homogeneidad interna.
            td(colspan="2") El lingote debe presentar una estructura uniforme, sin segregación de metales ni zonas débiles.
          tr
            td Ausencia de porosidad.
            td(colspan="2") No debe contener burbujas, cavidades o poros que afecten su resistencia y comportamiento mecánico.
          tr
            td Sin grietas o fisuras.
            td(colspan="2") Las fracturas internas o externas comprometen los procesos de laminado y estirado.
          tr
            td(rowspan="3") <strong>Físico-químicas.</strong>
            td Ley o pureza correcta.
            td(colspan="2") La proporción de metales debe corresponder exactamente a la aleación formulada.
          tr
            td Buena ductilidad.
            td(colspan="2") El lingote debe deformarse sin romperse durante el trabajo mecánico.
          tr
            td Punto de fusión estable.
            td(colspan="2") Debe fundirse de manera uniforme sin variaciones inesperadas debido a impurezas.
          tr
            td(rowspan="2") <strong>Geométricas.</strong>
            td Forma adecuada según el uso.
            td(colspan="2") Su diseño (plano, largo, grueso, etc.) debe responder al proceso que se realizará: laminado, trefilado o forjado.
          tr
            td Superficie pareja.
            td(colspan="2") Idealmente lisa y sin irregularidades excesivas que dificulten su transformación posterior.
          tr
            td(rowspan="2") <strong>Operativas.</strong>
            td Resistencia al trabajo mecánico.
            td(colspan="2") Debe soportar presión, golpes o tensión según el proceso de conformado.
          tr
            td Enfriamiento controlado.
            td(colspan="2") Una solidificación adecuada evita tensiones internas que puedan generar fracturas.
            
    Separador
    #t_8_4.titulo-segundo.color-acento-contenido
      .h2(data-aos="fade-right") 8.4 Defectos en los lingotes

    .bloque-texto-g.color-secundario.p-3.p-sm-4.p-md-5.z-2.mb-5
      .bloque-texto-g__img(
        :style="{'background-image': `url(${require('@/assets/curso/temas/tema8/8.png')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 Durante el proceso de fundición y solidificación del metal, los lingotes pueden presentar defectos que afectan su comportamiento mecánico y su calidad final. Estos problemas suelen originarse por fallas en la temperatura, mala preparación del molde, enfriamiento incorrecto o impurezas presentes en la aleación. Identificarlos y corregirlos es fundamental para evitar fracturas, pérdida de material y dificultades en procesos posteriores como laminado, trefilado o forja. Entre los defectos más comunes tenemos: 

    .titulo-sexto.color-acento-contenido.mb-4.z-2
      h5 Tabla 9.
      span Defectos en los lingotes
    .tabla-a.color-secundario.tabla-a--left.z-2
      table
        caption <strong>Fuente:</strong> SENA, 2025.
        thead(style="background-color: #FAF8F4;")
          tr
            th Defecto
            th Descripción
            th Causa principal
            th Cómo prevenirlo o corregirlo
        tbody
          tr
            td <strong>Porosidad.</strong>
            td Presencia de micro cavidades o burbujas internas.
            td Aire atrapado; falta de desgasificación; fundición a baja temperatura.
            td Uso de fundentes; asegurar buena fluidez; controlar temperatura.
          tr
            td <strong>Segregación.</strong>
            td Concentración desigual de los elementos de la aleación.
            td Enfriamiento lento o desigual; mezcla incompleta.
            td Mezcla adecuada; control térmico; uso de agitadores o movimientos suaves.
          tr
            td <strong>Grietas o fisuras.</strong>
            td Aperturas lineales en la superficie o interior.
            td Enfriamiento brusco; tensiones internas; impurezas.
            td Enfriamiento gradual; uso de moldes precalentados; limpieza del metal.
          tr
            td <strong>Cráter o hundimiento central.</strong>
            td Depresión en la parte superior del lingote.
            td Solidificación desde el exterior hacia el interior sin alimentación de metal.
            td Verter metal suficiente; controlar la solidificación.
          tr
            td <strong>Escorias o inclusiones.</strong>
            td Partículas sólidas atrapadas en el lingote.
            td Impurezas, restos de óxidos o mal uso de fundente.
            td Filtrado del metal; limpieza previa; fundentes adecuados.
          tr
            td <strong>Superficie rugosa o irregular.</strong>
            td Textura no uniforme o adherencias.
            td Molde frío; vibración; mala preparación del molde.
            td Precalentar molde; verter con firmeza; revisar estado del molde.
          tr
            td <strong>Contracción interna.</strong>
            td Vacíos internos generados al solidificar.
            td Enfriamiento descontrolado; poca alimentación de metal.
            td Mantener flujo de metal; controlar la velocidad de enfriamiento.
    
        

</template>

<script>
export default {
  name: 'Tema8',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
